import styles from './ProjectDescription.module.scss';

const ProjectDescription = ({ description }) => {
  console.log(description);
  return (<p className={styles.projectDescription}>{description}</p>)
}

export default ProjectDescription;